/* eslint-disable no-nested-ternary */
/* eslint-disable no-unused-vars */
/**
 * © [2022] Conduent, Inc. All rights reserved. Conduent®and Conduent Agile
 * Star®are trademarks of Conduent, Inc. and/or its subsidiaries in the United
 * States and/or other countries.
 */
import * as actiontypes from './actiontypes';
import axios from 'axios';
import _ from 'lodash';
import * as serviceEndPoint from '../../../../../SharedModules/services/service';

export const arSummaryData = (val) => {
  return { type: actiontypes.AR_SUMMARY_TABLE, payload: val };
};

export const arSummaryFldData = (val) => {
  return { type: actiontypes.AR_SUMMERY_FIELD, payload: val };
};

export const resetARSummaryByMfgData = () => {
  return { type: actiontypes.AR_SUMMERY_MFG_FIELD_CLEAR_REDUX };
};
